import React, {Component} from 'react'
import { connect } from 'react-redux'
import className from "classnames";
import axios from 'axios'
import * as actions from "./../../actions";
import _ from "lodash";
import "./UpdateOccmUris.css"
import {AddCircleIcon, StarIcon, StarBorderIcon} from "./../svg-icons/Icons"
import uuidv4 from "uuid/v4";
import closeIcon from "images/icons/x-circle-icon.svg"
import Isvg from 'react-inlinesvg';
import { Scrollbars } from 'react-custom-scrollbars';
import { InfoIcon } from 'components/svg-icons/Icons';
import Tooltip from 'material-ui/Tooltip';

class DumbUpdateIpsDialog extends Component {
    constructor(props){
        super(props);
        const {occm} = props;
        const manualOverrideUris = occm.manualOverrideUris || [];
        const automaticCallbackUris = occm.automaticCallbackUris || [];
        props.clearUpdateOccmState();
        const uris = _.cloneDeep([{value: automaticCallbackUris[0]}].concat(manualOverrideUris));
        if(!manualOverrideUris.find(el => el.isDefault)){
            uris[0].isDefault = true;
        }

        uris.forEach(uri => {
            uri.uuid = uuidv4();
        });

        this.state = {uris};
    }

    addNewUri(){
        this.props.clearUpdateOccmState();
        this.setState({uris: this.state.uris.concat([{uuid: uuidv4(), value: "", isDefault: false}])})
    }

    setUriAsDefault(uri){
        if(!uri.value) return;
        this.props.clearUpdateOccmState();
        this.state.uris.forEach(el => {
           el.isDefault = false;
        });

        uri.isDefault = true;
        this.setState({uris: this.state.uris});
    }

    handleUriChange(uri, event){
        this.props.clearUpdateOccmState();
        uri.value = event.target.value;
        this.setState({uris: this.state.uris});
    }

    removeUri(uri){
        this.props.clearUpdateOccmState();
        if(uri.isDefault){
            // eslint-disable-next-line
            this.state.uris[0].isDefault = true;
        }
        this.setState({uris: _.without(this.state.uris, uri)})
    }

    render(){
        const {closeDialog, editOccmState, occm, updateOccmUris} = this.props;

        const wrappedEdit = () => {
            this.setState({uris: _.filter(this.state.uris, (el) => {
                return el.value;
            })}, () => {
                updateOccmUris(occm.occm, _.drop(this.state.uris, 1)).then(() => {
                    closeDialog()
                })
            });
        };
        return (<div>
                <h3>Update '<span className="text-ellipsis" style={{maxWidth: 368, display: "inline-block", position: "relative", top: 5}}>{occm.occmName}</span>' URIs</h3>
                <div className={className("dialog-content", {error: editOccmState.status === actions.STATUS_ERROR})}>
                    <Scrollbars
                        thumbSize={126}
                        style={{ width: "calc(100% + 15px)", height: 186}}
                        renderThumbVertical={props => {
                            const style = props.style;
                            return <div {...props} style={{...style, cursor: "pointer", width: "5px", borderRadius: "5px", backgroundColor: "#e9e9e9"}} />
                        }}>
                        {
                            this.state.uris.map((uri, index) =>
                                <div key={uri.uuid} className={className("uri-row", {isDefault: uri.isDefault})}>
                                    <div style={{marginBottom: 3}}>
                                        <label>{index === 0 ? "Cloud Manager Address (Automatically Set)" : `URI ${index + 1}` }</label>
                                        <button className="mark-default" onClick={() => this.setUriAsDefault(uri)}>
                                            {uri.isDefault ? <StarIcon/> : <StarBorderIcon/>}
                                            Mark as default
                                        </button>
                                    </div>
                                    <div>
                                        <input disabled={index === 0 ? "disabled" : false} autoFocus value={uri.value} onChange={(event) => this.handleUriChange(uri, event)}/>
                                        {index !== 0 && <button className="remove-uri" onClick={() => this.removeUri(uri)}>
                                            <Isvg src={closeIcon}/>
                                        </button>}
                                    </div>
                                    {editOccmState.hasInvalidUris && editOccmState.invalidUris.includes(index - 1) &&  <div className="error-text">
                                        Invalid URI
                                    </div>}
                                </div>
                            )
                        }
                    </Scrollbars>

                    <button className="add-new-uri" onClick={() => this.addNewUri()}>
                        <AddCircleIcon/>
                        Add New URI
                    </button>
                </div>
                {editOccmState.status === actions.STATUS_ERROR &&
                <div  style={{position: "absolute", fontSize: 13, fontWeight: "normal"}}>
                    <Tooltip id="tooltip-icon" style={{cursor: "help"}} title={editOccmState.hasInvalidUris ? "Provided URIs are invalid." : editOccmState.data.message} placement="top" classes={{root: "launching-text", tooltip: "hanging-tooltip"}}>
                        <span>
                            <InfoIcon style={{position: "relative", top: "8px", marginRight: "6px", color: "#ca3658"}} />
                            <span style={{color: "#ca3658"}} >Failed to edit URIs</span>
                        </span>
                    </Tooltip>
                </div>
                }
                <div className="dialog-buttons">
                    <button className="cancel medium right" onClick={closeDialog} disabled={editOccmState.status === actions.STATUS_PENDING}>Cancel</button>
                    <button className="secondary medium right" onClick={wrappedEdit} disabled={editOccmState.status === actions.STATUS_PENDING}>{editOccmState.status === actions.STATUS_PENDING ? "Saving..." : "Save"}</button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateOccmUris: (occmId, uris) => {
            const payload =  axios.post("/occm/manual-update-uris", {
                occmId,
                redirectUris: uris
            });

            dispatch({
                type: "UPDATE-OCCM-URIS",
                payload
            });

            return payload;
        },
        clearUpdateOccmState: () => {
            dispatch({
                type: "CLEAR-UPDATE-OCCM-URIS-STATE"
            })
        }
    }
};

const mapStateToProps = state => {
    return {
        editOccmState: state.services.editOccmState || {}
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DumbUpdateIpsDialog);


// WEBPACK FOOTER //
// ./src/components/launch-pad/UpdateOccmIps.js